import {createRouter, createWebHistory} from 'vue-router';

function createRoutes(ignored_app) {
    return [
        {
            path: '/impressum',
            component: () => import('../../components/views/Impressum.vue'),
        },
        // {
        //     path: '/:catchAll(.*)',
        //     components: {
        //         default: () => import(/* webpackChunkName: "notFound" */ '../../components/views/home.vue'),
        //     }
        // },
    ];
}

export default (app) => {
    return createRouter({
        history: createWebHistory(process.env.BASE_URL),
        routes: createRoutes(app),
    })
}
